import HikSetTriggerAlarmModal from './hik-set-trigger-alarm-modal.vue'
export default HikSetTriggerAlarmModal
